/**
 * MARKA — firma adinin kodda gectigi TEK yer.
 *
 * CLAUDE.md: "Firma adini herhangi bir dosyaya gomme."
 * Deger derleme aninda ortamdan gelir; belli oldugunda yalnizca .env
 * dosyasi degisir, tek satir kod degismez.
 */
export interface Marka {
  ad: string;
  kisaAd: string;
  destekEposta: string;
  /**
   * Uygulama surumu — `package.json`dan derleme aninda geliyor
   * (`vite.config.ts` degeri `process.env.VITE_APP_SURUM` olarak
   * koyuyor; Vite `VITE_` onekli surec degiskenlerini `import.meta.env`
   * icine tasiyor).
   *
   * ELDE EDILEMEDIYSE `null` — testte ve `vite` disinda calisirken
   * boyle oluyor. Sabit bir varsayilan yazsaydik iki gercek olurdu:
   * `package.json` ilerlerken buradaki sayi eskir ve destek ekibi
   * yanlis surume bakarak karar verirdi.
   */
  surum: string | null;
}

function oku(anahtar: string, varsayilan: string): string {
  // Vite `import.meta.env` uzerinden derleme aninda enjekte eder.
  const env = (import.meta as unknown as { env?: Record<string, string | undefined> }).env;
  return env?.[anahtar] ?? varsayilan;
}

export const marka: Marka = {
  ad: oku("VITE_BRAND_NAME", "[FIRMA ADI]"),
  kisaAd: oku("VITE_BRAND_SHORT", "[KISA AD]"),
  destekEposta: oku("VITE_SUPPORT_EMAIL", "destek@example.com"),
  surum: oku("VITE_APP_SURUM", "") || null,
};

/*
  ================================================================
  YER TUTUCU GORUNUYORSA GELISTIRICIYE BAGIR — 05.09.2026
  ================================================================
  Emre panele girdi ve sol ustte `[KISA AD]` gordu. Kod DOGRUYDU:
  `Kabuk.tsx` `marka.kisaAd` okuyor, kok depoda
  `VITE_BRAND_SHORT="Mentor"` yazili.

  Sebep baskaydi: paneli sunan sunucu bir WORKTREE'de calisiyordu ve
  o worktree'de `.env.local` YOKTU. `.env.local` .gitignore'da (dogru,
  sir tasiyor) ve worktree'ler onu devralmiyor.

  NEDEN AYLARCA GORUNMEDI: CLAUDE.md "firma adi belli degil, yer
  tutucu gormen NORMALDIR" diyor. Yer tutucu ekranda defalarca
  goruldu ve her seferinde "normal" diye gecildi.

  BEKLENEN BIR YANLIS, FARK EDILMEYEN BIR YANLISTIR. Sorun olcum
  aracinda degildi; olcmeye deger gorulmemesindeydi.

  KOD BEKCISI BUNU YAKALAYAMAZ: kaynakta yer tutucunun OLMASI
  gerekiyor (`marka-tek-kaynak.test.ts` yalnizca ELLE yazilmasini
  yasakliyor, ki dogru). Yakalanabilecek tek an CALISMA ANI.

  Bu yuzden gelistirmede yuksek sesle soyluyor. Uretimde SUSUYOR:
  orada konsola yazmak kullaniciya bir sey kazandirmaz ve marka
  gercekten belirsizse bunu gorecek kisi zaten gelistirici degil.

  `console.error` BILEREK — `warn` degil. Gelistirici konsolu
  uyarilarla dolu; bu satirin kaybolmamasi gerekiyor.
*/
if (typeof console !== "undefined") {
  const env = (import.meta as unknown as { env?: Record<string, unknown> }).env;
  const gelistirme = env?.DEV === true;
  const eksikler = [
    marka.ad === "[FIRMA ADI]" ? "VITE_BRAND_NAME" : null,
    marka.kisaAd === "[KISA AD]" ? "VITE_BRAND_SHORT" : null,
  ].filter((x): x is string => x !== null);

  if (gelistirme && eksikler.length > 0) {
    /*
      Satırlar bir DİZİ ve `join` ile birleşiyor — kaynağa `\n` kaçış
      dizisi yazılmıyor. Sebebi ölçüldü: bu dosya bir kabuk katmanından
      geçerken `\n` GERÇEK SATIR SONUNA dönüştü ve dizgiyi ortasından
      böldü (TS1002). Aynı tuzak bu depoda bugün dördüncü kez.
    */
    console.error(
      [
        `[marka] ${eksikler.join(", ")} tanımlı değil — ekranda yer tutucu görünüyor.`,
        "Bu bir kod hatası değil: bu sunucunun çalıştığı dizinde `.env.local` yok.",
        "Worktree'de çalışıyorsan kök `.env.local` dosyasını oraya kopyala ve",
        "sunucuyu YENİDEN BAŞLAT (Vite ortam dosyasını yalnızca açılışta okur).",
      ].join(" "),
    );
  }
}
